import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/customerService',
    name: 'customerService.vue',
    component: () => import('../views/customerService.vue')
  },
  {
    path: '/register',
    name: 'register.vue',
    component: () => import('../views/register.vue')
  },
  {
    path: '/raffleRegister',
    name: 'raffleRegister.vue',
    component: () => import('../views/raffleRegister.vue')
  }, {
    path: '/privacy',
    name: 'privacy.vue',
    component: () => import('../views/privacy.vue')
  },
]
  
const router = new VueRouter({
  mode:'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
